export default __webpack_public_path__ + "static/media/symptoms.5e5eb6ea.mp4";